<template>
    <transition name="fade">
        <div v-if="selectedStation.show">
            <div class="offcanvas-wrapper">
                <div class="offcanvas-sidebar container-fluid">
                    <div class="row align-items-center" style="height: 100%;">

                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
  },
  props: {
  },
  data() {
    return {
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions([
      'hideStationDetail'
    ])
  },
  computed: {
    ...mapGetters({
      selectedStation: 'selectedStation'
    })
  },
  filters: {
    clean: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.replace(/-/g, ' ').toUpperCase()
    }
  }
}
</script>

<style lang="scss">

.fade-enter-active, .fade-leave-active {
  transition: all .5s ease-in-out;
  .offcanvas-sidebar {
    transition: all .5s ease-in-out;
  }
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  .offcanvas-sidebar {
    right: -100%;
  }
}

.offcanvas-sidebar {
    background: white;
    position: absolute;
    width: 33.333%;
    height: 100%;
    right: 0;
  }
</style>


// WEBPACK FOOTER //
// stationDetail.vue?1e0d572e